<template>
    <div>
        <!-- <div class="fx-header goback">
            <p>运费</p>
        </div> -->
		<div class="store-name">
			<span>
				<i class="el-icon-back" @click="goBack"></i>
			</span>
			<span>{{id ? '编辑' : '新增'}}运费模板(常规)</span>
		</div>
        <div class="container">
            <div style="display:flex;flex-direction:column;height:100%;">
				<div class="template-name">
					<span style="color:#F03939;">*</span>模板名称:<el-input size='mini' class="name-input" v-model="templateName" placeholder="不超过50个字" maxlength="50"></el-input>
					<el-checkbox v-model="calcgiftFlag">赠品是否计算运费</el-checkbox>
					<span class="edit-time" v-if="modifyDate">上次编辑时间:{{modifyDate}}</span>
				</div>
				<div style="margin-top: 10px">
					<div style="line-height: 30px">
						<el-checkbox v-model="freeflag">是否参与免运费</el-checkbox>
					</div>
					<div style="line-height: 30px;margin-left: 20px;">
						<el-radio v-model="freearea" :disabled="!freeflag" :label="0">
							不限区域订单商品金额满
							<el-input size='mini' type='number' @blur="freemoneyBlur" style="width: 100px;margin: 0 5px;" v-model="freemoney"></el-input>
							元免运费
						</el-radio>
					</div>
					<div style="line-height: 30px;margin-left: 20px;">
						<el-radio v-model="freearea" :disabled="!freeflag" :label="1">
							限区域
						</el-radio>
					</div>
				</div>
				<div style="display:flex;flex-direction:column;flex:1">
					<div class="table-box">
						<div class="table-wrap">
							<div class="freight-table-head">
								<div class="flex-one">可配送区域<i class="el-icon-circle-plus-outline area-add" @click="addClick"></i></div>
								<div class="flex-one" style="width: 200px;" v-if="freeflag && freearea === 1">免运费规则</div>
								<div class="flex-all">
									<div class="flex-four">
										运输方式
										<el-tooltip effect="dark" placement="top-start">
											<div slot="content">
												<div style="font-size: 14px;">运输方式计费说明：</div>
												<div style="font-size: 12px;">1、不限与其他运输方式不可同时选择</div>
												<div style="font-size: 12px;">2、选择不限时，计算运费不与商品信息中运费方式相关联，与订单维度计算运费</div>
												<div style="font-size: 12px;">3、选择非不限时，计算运费与商品信息中运费方式相关联，以模板中相应运输方式对应的计费规则计算运费</div>
											</div>
											<i class="el-icon-info" style="margin-left: 5px;color:var(--fx-primary-color);"></i>
										</el-tooltip>
									</div>
									<div class="flex-four">计费方式</div>
									<div class="flex-two">计费规则</div>
									<div class="flex-three"></div>
								</div>
							</div>
							<div class="freight-content-wrap">
								<div class="freight-table-content" v-for="(allItem, allIndex) in areaTableData" :key="allItem.id">
									<div class="flex-one" style="display: flex;align-items: center;justify-content: center;">
										<el-button size='mini' @click="editTree(allItem, allIndex)" style="padding:0 20px;line-height:20px;white-space:normal;" type='text' :title="allItem.areaname">{{allItem.showname}}
										</el-button>
									</div>
									<div class="flex-one" style="width: 200px;" v-if="freeflag && freearea === 1">
										<div class="rule-box" >
											订单商品金额满
											<el-input type='number' size='mini' style="width: 100px;margin: 0 5px;" @blur="itemFreemoneyBlur(allIndex)" v-model="allItem.freemoney"></el-input>
											元免运费
										</div>
									</div>
									<div class="flex-all" style="flex-direction: column;">
										<div v-for="(item, index) in allItem.dataList" :key="index" style="width: 100%; display:flex;">
											<div class="flex-four">
												<span v-if="item.transportMode === 0">不限</span>
												<span v-if="item.transportMode === 1">常温运输</span>
												<span v-if="item.transportMode === 2">冷链运输</span>
											</div>
											<div class="flex-four">
												<el-select v-model="item.pricingType" size='small' placeholder="请选择" style="width:85%;">
													<el-option :value="0" label="一口价"></el-option>
													<el-option :value="1" label="按订单金额：阶梯价"></el-option>
													<el-option :value="2" label="按订单金额：比例价"></el-option>
													<el-option :value="5" label="按订单件数：固定件数"></el-option>
													<el-option :value="6" label="按订单件数：阶梯件数"></el-option>
													<el-option :value="7" label="按订单重量：固定重量"></el-option>
													<el-option :value="9" label="阶梯件数：超出起步价部分，每件"></el-option>
													<el-option :value="10" label="阶梯件数：超出起步价部分，一律每件"></el-option>
												</el-select>
											</div>
											<div class="flex-two" style="padding: 10px 0;">
												<div class="rule-box" v-if="item.pricingType === 0">
													一口价<el-input size='mini' class="cell-input" :class="{'input-error': item.isError === 0}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="item.fixedMoney" @change="areaChange(item,'fixedMoney', index, allIndex)"></el-input>元
												</div>
												<div class="rule-box two-box" v-if="item.pricingType === 1">
													<div v-for="(childItem, childIndex) in item.freightTemplatePricingDTOList" :key="childIndex" class="two-wrap">
														<div class="step-box">订单金额于<el-input size='mini' class="cell-input" type='number' v-model="childItem.minValue" disabled></el-input>元（含）~<el-input size='mini' class="cell-input" type='number' v-model="childItem.maxValue" :disabled="childIndex !== item.freightTemplatePricingDTOList.length-1" @change="stepMoneyChange(childIndex, index,'maxValue', allIndex)"></el-input>元（不含）
														，收<el-input size='mini' class="cell-input" :class="{'input-error': childItem.isError === 1}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="childItem.freightMoney" @change="stepMoneyChange(childIndex, index,'freightMoney', allIndex)"></el-input>元
														<el-button size='mini' v-if='childIndex === item.freightTemplatePricingDTOList.length-1 && childItem.maxValue && parseFloat(childItem.maxValue) > parseFloat(childItem.minValue)' class="time-btn" icon="el-icon-plus" circle @click="addTimeClick(childItem.maxValue, index, allIndex)"></el-button>
														<el-button size='mini' v-if='item.freightTemplatePricingDTOList.length > 1 && childIndex === item.freightTemplatePricingDTOList.length-1' class="time-btn" icon="el-icon-minus" circle @click="delTimeClick(childIndex, index, allIndex)"></el-button></div>
													</div>
												</div>
												<div class="rule-box" style="display:flex;align-items:center;" v-if="item.pricingType === 2">
													订单金额比例的<el-input size='mini' class="cell-input" :class="{'input-error': item.isError === 2}" type='number' v-model="item.percentMoney" :disabled="!AuthorityList['01_0003_0001_00']" @change="areaChange(item,'percentMoney', index, allIndex)"></el-input>%
													<el-tooltip effect="dark" placement="right" popper-class="tip-class">
														<div slot="content">订单商品总金额的比例收取运费。<br/>例如：一张订单：商品总额：1000元,运费按照：订单金额比例的0.1%获取，则该订单的运费 = 1000 * 0.1% = 1元</div>
														<img src="~/images/icon/tooltip-icon.png" class="tip-icon">
													</el-tooltip>
												</div>
												<div class="rule-box" v-if="item.pricingType === 5">
													<div>
														首费:<el-input size='mini' class="cell-input" :class="{'input-error': item.isError === 5}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="item.numberFixed" @change="areaChange2(item,'numberFixed', index, allIndex)"></el-input>件（包含及以下）,
														<el-input size='mini' class="cell-input" :class="{'input-error': item.isError === 5}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="item.numberMoney" @change="areaChange2(item,'numberMoney', index, allIndex)"></el-input>元;续费:超出每件
														<el-input size='mini' class="cell-input" :class="{'input-error': item.isError === 5}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="item.numberStepMoney" @change="areaChange2(item,'numberStepMoney', index, allIndex)"></el-input>元;
														<el-radio v-model="item.topOffRadio" label="1">无封顶</el-radio><el-radio v-model="item.topOffRadio" label="2">封顶<el-input size='mini' class="cell-input" :class="{'input-error': item.isError === 5}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="item.topOffValue" @change="areaChange2(item,'topOffValue', index, allIndex)"></el-input>件</el-radio>
													</div>
												</div>
												<div class="rule-box two-box" v-if="item.pricingType === 6">
													<div v-for="(childItem, childIndex) in item.freightTemplatePricingDTOList2" :key="childIndex" class="two-wrap">
														<div class="step-box">订单件数于<el-input size='mini' class="cell-input" type='number' v-model="childItem.minValue" disabled></el-input>件（含）~<el-input size='mini' class="cell-input" type='number' v-model="childItem.maxValue" :disabled="childIndex !== item.freightTemplatePricingDTOList2.length-1" @change="stepMoneyChange2(childIndex, index,'maxValue', allIndex)"></el-input>件（不含）
														，收<el-input size='mini' class="cell-input" :class="{'input-error': childItem.isError === 1}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="childItem.freightMoney" @change="stepMoneyChange2(childIndex, index,'freightMoney', allIndex)"></el-input>元
														<el-button size='mini' v-if='childIndex === item.freightTemplatePricingDTOList2.length-1 && childItem.maxValue && parseFloat(childItem.maxValue) > parseFloat(childItem.minValue)' class="time-btn" icon="el-icon-plus" circle @click="addTimeClick2(childItem.maxValue, index, allIndex)"></el-button>
														<el-button size='mini' v-if='item.freightTemplatePricingDTOList2.length > 1 && childIndex === item.freightTemplatePricingDTOList2.length-1' class="time-btn" icon="el-icon-minus" circle @click="delTimeClick2(childIndex, index, allIndex)"></el-button></div>
													</div>
												</div>
												<div class="rule-box" v-if="item.pricingType === 7">
													<div>
														首费:<el-input size='mini' class="cell-input" :class="{'input-error': item.isError === 7}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="item.numberFixed" @change="areaChange2(item,'numberFixed', index, allIndex)"></el-input>KG（包含及以下）,
														<el-input size='mini' class="cell-input" :class="{'input-error': item.isError === 7}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="item.numberMoney" @change="areaChange2(item,'numberMoney', index, allIndex)"></el-input>元;续费:超出每KG
														<el-input size='mini' class="cell-input" :class="{'input-error': item.isError === 7}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="item.numberStepMoney" @change="areaChange2(item,'numberStepMoney', index, allIndex)"></el-input>元;
														<el-radio v-model="item.topOffRadio" label="1">无封顶</el-radio><el-radio v-model="item.topOffRadio" label="2">封顶<el-input size='mini' class="cell-input" :class="{'input-error': item.isError === 7}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="item.topOffValue" @change="areaChange2(item,'topOffValue', index, allIndex)"></el-input>KG</el-radio>
													</div>
												</div>
												<div class="rule-box two-box" v-if="item.pricingType === 9">
													<div v-for="(childItem, childIndex) in item.freightTemplatePricingDTOList2" :key="childIndex" class="two-wrap">
														<div class="step-box">
															<el-input size='mini' class="cell-input" type='number' v-model="childItem.minValue" disabled></el-input>
															~
															<el-input size='mini' class="cell-input" type='number' v-model="childItem.maxValue" :disabled="childIndex !== item.freightTemplatePricingDTOList2.length-1" @change="stepMoneyChange2(childIndex, index,'maxValue', allIndex)"></el-input>
															<span v-if="childIndex === 0">件（不含），运费固定</span>
															<span v-else>件（不含），按照每件</span>
															<el-input size='mini' class="cell-input" :class="{'input-error': childItem.isError === 9}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="childItem.freightMoney" @change="stepMoneyChange2(childIndex, index,'freightMoney', allIndex)"></el-input>
															<span v-if="childIndex === 0">元</span>
															<span v-else>元收取</span>
															<el-select v-if="childIndex === 0" v-model="item.detailtype" size='small' placeholder="请选择" style="width:240px;margin-top: 10px">
																<el-option :value="0" label="超出起送件数，每件"></el-option>
																<el-option :value="1" label="超出起送件数，超出部分每件"></el-option>
															</el-select>
															<el-button size='mini' v-if='childIndex === item.freightTemplatePricingDTOList2.length-1 && childItem.maxValue && parseFloat(childItem.maxValue) > parseFloat(childItem.minValue)' class="time-btn" icon="el-icon-plus" circle @click="addTimeClick2(childItem.maxValue, index, allIndex)"></el-button>
															<el-button size='mini' v-if='item.freightTemplatePricingDTOList2.length > 1 && childIndex === item.freightTemplatePricingDTOList2.length-1' class="time-btn" icon="el-icon-minus" circle @click="delTimeClick2(childIndex, index, allIndex)"></el-button></div>
														</div>
													<!-- <div class="step-box">
														0-
														<el-input size='mini' class="cell-input" :class="{'input-error': item.isError === 8}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="item.numberFixed" @change="areaChange2(item,'numberFixed', index, allIndex)"></el-input>
														件，起步价
														<el-input size='mini' class="cell-input" :class="{'input-error': item.isError === 8}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="item.numberMoney" @change="areaChange2(item,'numberMoney', index, allIndex)"></el-input>
														元，超出部分，按照每件
														<el-input size='mini' class="cell-input" :class="{'input-error': item.isError === 8}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="item.numberStepMoney" @change="areaChange2(item,'numberStepMoney', index, allIndex)"></el-input>
														元收取
													</div> -->
												</div>
												<div class="rule-box" v-if="item.pricingType === 10">
													<div class="step-box">
														0-
														<el-input size='mini' class="cell-input" :class="{'input-error': item.isError === 10}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="item.numberFixed" @change="areaChange2(item,'numberFixed', index, allIndex)"></el-input>
														件，起步价
														<el-input size='mini' class="cell-input" :class="{'input-error': item.isError === 10}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="item.numberMoney" @change="areaChange2(item,'numberMoney', index, allIndex)"></el-input>
														元，只要超出起步件数，一律按照每件
														<el-input size='mini' class="cell-input" :class="{'input-error': item.isError === 10}" type='number' :disabled="!AuthorityList['01_0003_0001_00']" v-model="item.numberStepMoney" @change="areaChange2(item,'numberStepMoney', index, allIndex)"></el-input>
														元收取
													</div>
												</div>
											</div>
											<div class="flex-three">
												<el-button size='mini' v-if="(areaTableData.length > 1 || areaTableData[0].dataList.length> 1) && AuthorityList['01_0003_0003_00']" style="padding:4px" icon="el-icon-minus" circle @click="deleteClick(allIndex, index)"></el-button>
												<el-button size='mini' v-if="areaTableData.length - 1 === allIndex" style="padding:4px" icon="el-icon-plus" circle @click="addTransportMode(allIndex)"></el-button>
											</div>
										</div>
										<div class="flex-all">
											<div class="btn-row" style="flex: 1;">
												<el-button size="mini" type="text" @click="addTransportMode(allIndex)">+添加运输方式</el-button>
											</div>
											<div class="flex-three">
											</div>
										</div>
										<div class="flex-all">
											<div class="btn-row" style="flex: 1; align-items: center;">
												<el-button size="mini" style="margin-right: 20px;" type="text" @click="addOtherMoney(allIndex)">添加其他费用</el-button>
												<div v-if="allItem.feeTollType === 1">高速费：{{allItem.feeToll}}元</div>
												<div v-if="allItem.feeTollType === 1 && allItem.bridgeTollType === 1">、</div>
												<div v-if="allItem.bridgeTollType === 1">过桥费：{{allItem.bridgeToll}}元</div>
											</div>
											<div class="flex-three">
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
            <el-dialog
                title="选择配送区域"
                :visible.sync="showTree"
                class="dialog-title"
                width="800px"
                :close-on-click-modal="false">
                <tree @dialogClose="dialogClose" :delList='delList' :disabled='isDisabled' @addArea='addArea' :typeRadio='typeRadio' :treeId='treeId' :freightId='id' :isCheckedArrHalf='checkedArrHalf' :isCheckedArr='checkedArr' :isAdd='addTree' v-if="showTree"/>
            </el-dialog>
			<el-dialog
				title="选择新增运输方式"
				:visible.sync="selectMethodShow"
				class="dialog-title"
				width="500px"
				:close-on-click-modal="false">
				<div style="height: 40px; line-height:40px">
					<el-checkbox-group v-model="checkList">
						<el-checkbox :label="0" v-if="selectArr.indexOf(0) === -1" @change="checkChange(0)">不限</el-checkbox>
						<el-checkbox :label="1" v-if="selectArr.indexOf(1) === -1" @change="checkChange(1)">常温运输</el-checkbox>
						<el-checkbox :label="2" v-if="selectArr.indexOf(2) === -1" @change="checkChange(2)">冷链运输</el-checkbox>
					</el-checkbox-group>
				</div>
				<div style="text-align: center;">
					<el-button size='small' class="fx-big-btn" type="primary" @click="addTransportModeHandel">确定</el-button>
				</div>
			</el-dialog>
			<el-dialog
				title="选择新增其他费用"
				:visible.sync="otherShow"
				class="dialog-title"
				width="500px"
				:close-on-click-modal="false">
				<div>
					<div class="row-box">
						<el-checkbox style="margin-right: 10px;" v-model="feeTollType" :true-label="1" :false-label="0">高速费</el-checkbox>
						<span v-if="feeTollType">收</span>
						<el-input @blur="blurFeeTollMoney" v-if="feeTollType" size='mini' class="cell-input" type='number' v-model="feeToll" placeholder="请输入高速费"></el-input>
						<span v-if="feeTollType">元</span>
					</div>
					<div class="row-box">
						<el-checkbox style="margin-right: 10px;" v-model="bridgeTollType" :true-label="1" :false-label="0">过桥费</el-checkbox>
						<span v-if="bridgeTollType">收</span>
						<el-input @blur="blurBridgeTollMoney" v-if="bridgeTollType" size='mini' class="cell-input" type='number' v-model="bridgeToll" placeholder="请输入过桥费"></el-input>
						<span v-if="bridgeTollType">元</span>
					</div>
				</div>
				<div style="text-align: center;margin-top: 10px;">
					<el-button size='small' class="fx-big-btn" type="primary" @click="addOtherMoneyHandel">确定</el-button>
				</div>
			</el-dialog>
			<el-dialog
				title="提示"
				:visible.sync="waringShow"
				class="dialog-title"
				@close='closeWaring'
				width="500px"
				:close-on-click-modal="false">
				<div>
					<i style="font-size: 18px;color: #E6A23C;" class="el-icon-warning"></i>
					{{waringText}}
				</div>
				<div style="text-align: center;margin-top: 10px;">
					<el-button size='small' type="primary" @click="closeWaring">确定</el-button>
				</div>
			</el-dialog>
        </div>
		<div class="btn-feight-box" v-if="AuthorityList['01_0003_0001_00']">
			<el-button size='small' class="fx-big-btn" type="primary" @click="submitForm">保存</el-button>
		</div>
    </div>
</template>

<script>
import tree from '@/components/freight/tree.vue'
import { codeToCity } from '@/js/location/codeToCtiy.js'
export default {
	name: 'freight',
	components: {
		tree
	},
	data () {
		return {
			feeToll: 0,
			bridgeToll: 0,
			feeTollType: 0,
			bridgeTollType: 0,
			otherIndex: null,
			otherShow: false,
			AuthorityList: {
				'01_0003_0001_00': false,
				'01_0003_0002_00': false,
				'01_0003_0003_00': false,
				'01_0003_0004_00': false
			},
			provinceList: [
				'110000',
				'120000',
				'130000',
				'140000',
				'150000',
				'210000',
				'220000',
				'230000',
				'310000',
				'320000',
				'330000',
				'340000',
				'350000',
				'360000',
				'370000',
				'410000',
				'420000',
				'430000',
				'440000',
				'450000',
				'460000',
				'500000',
				'510000',
				'520000',
				'530000',
				'540000',
				'610000',
				'620000',
				'630000',
				'640000',
				'650000',
				'710000',
				'810000',
				'820000',
				'900000'
			],
			isDisabled: true,
			isChanged: false,
			sftid: null,
			totalCount: 0,
			targettype: 1,
			week: [1, 2, 3, 4, 5, 6, 7],
			selfpickTimes: [{ val: ['08:30', '17:30'] }],
			buyerselfpickflag: false,
			samedayflag: true,
			delList: [],
			id: '',
			treeId: '',
			addTree: false,
			isAdd: false,
			showTree: false,
			areaTableData: [],
			deliveryflag: true,
			selfPickFlag: true,
			typeRadio: 0,
			freightType: 1,
			effectText: '',
			page: {
				size: 20,
				num: 1
			},
			productTableData: [],
			shopTableData: [],
			tableHeight: '100%',
			selfpickMoney: 0,
			form: {
				deliveryWay: [0],
				sendamount: 0,
				name: '',
				templatetype: 0,
				freighttype: 0
			},
			rules: {
				name: [
					{ required: true, message: '请输入模板名称', trigger: 'blur' }
				],
				sendamount: [
					{ required: true, message: '请输入起订金额', trigger: 'blur' }
				],
				templatetype: [
					{ required: true, message: '请选择模板类型', trigger: 'change' }
				],
				freighttype: [
					{ required: true, message: '请选择计费方式', trigger: 'change' }
				]
			},
			templateName: '',
			calcgiftFlag: false,
			freeflag: false,
			checkedArr: {},
			checkedArrHalf: {},
			editIndex: null,
			modifyDate: '',
			matchbillcenterflag: 0,
			selectMethodShow: false,
			selectArr: [],
			checkList: [],
			allIndex: null,
			waringShow: false,
			waringText: '',
			freearea: 0,
			freemoney: ''
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '2-4')
		this.getAuthority('01_0003_0000_00')
		this.checkSmallCategory()
		if (this.$route.query.id) {
			this.id = this.$route.query.id
			this.get()
		}
	},
	// beforeRouteLeave (to, from, next) {
	// 	let that = this
	// 	if (this.isChanged) {
	// 		this.$confirm('修改尚未保存，是否退出？', '提示', {
	// 			confirmButtonText: '保存并退出',
	// 			cancelButtonText: '直接退出',
	// 			type: 'warning',
	// 			closeOnClickModal: false
	// 		}).then(() => {
	// 			this.submitForm().then(res => {
	// 				next()
	// 			}).catch(res => {
	// 				that.$fxEventBus.$emit('setMenu', '2-8')
	// 				this.$nextTick(() => {
	// 					that.$fxEventBus.$emit('setMenu', '2-4')
	// 				})
	// 			})
	// 		}).catch(() => {
	// 			next()
	// 		})
	// 	} else {
	// 		next()
	// 	}
	// },
	methods: {
		blurFeeTollMoney () {
			if (this.feeToll !== '') {
				if (this.feeToll > 100000000) {
					this.feeToll = 99999999.99
				} else {
					this.feeToll = this.$fxUtils.toFixedSHW(this.feeToll, 2)
				}
			}
		},
		blurBridgeTollMoney () {
			if (this.bridgeToll !== '') {
				if (this.bridgeToll > 100000000) {
					this.bridgeToll = 99999999.99
				} else {
					this.bridgeToll = this.$fxUtils.toFixedSHW(this.bridgeToll, 2)
				}
			}
		},
		itemFreemoneyBlur (index) {
			if (this.areaTableData[index].freemoney !== '') {
				if (this.areaTableData[index].freemoney > 100000000) {
					this.areaTableData[index].freemoney = 99999999.99
				} else {
					this.areaTableData[index].freemoney = this.$fxUtils.toFixedSHW(this.areaTableData[index].freemoney, 2)
				}
			}
		},
		freemoneyBlur () {
			if (this.freemoney !== '') {
				if (this.freemoney > 100000000) {
					this.freemoney = 99999999.99
				} else {
					this.freemoney = this.$fxUtils.toFixedSHW(this.freemoney, 2)
				}
			}
		},
		checkChange (data) {
			let flag = this.checkList.indexOf(data) !== -1
			if (flag) {
				let arr = []
				this.checkList.forEach(item => {
					if (data === 0) {
						if (item === 0) {
							arr.push(item)
						}
					} else {
						if (item === 1 || item === 2) {
							arr.push(item)
						}
					}
				})
				this.checkList = arr
			}
		},
		addOtherMoney (index) {
			this.otherIndex = index
			this.feeToll = this.areaTableData[index].feeToll || 0
			this.bridgeToll = this.areaTableData[index].bridgeToll || 0
			this.feeTollType = this.areaTableData[index].feeTollType || 0
			this.bridgeTollType = this.areaTableData[index].bridgeTollType || 0
			this.otherShow = true
		},
		addOtherMoneyHandel () {
			this.areaTableData[this.otherIndex].feeToll = this.feeToll
			this.areaTableData[this.otherIndex].bridgeToll = this.bridgeToll
			this.areaTableData[this.otherIndex].feeTollType = this.feeTollType
			this.areaTableData[this.otherIndex].bridgeTollType = this.bridgeTollType
			this.otherShow = false
		},
		addTransportMode (index) {
			this.selectArr = []
			let arr = []
			let list = this.areaTableData[index].dataList
			list.forEach(item => {
				arr.push(item.transportMode)
			})
			this.allIndex = index
			this.selectArr = arr
			this.checkList = []
			this.selectMethodShow = true
		},
		addTransportModeHandel () {
			if (this.checkList.length === 0) {
				this.$message.error('请选择运输方式')
				return false
			}
			if (this.checkList.indexOf(0) !== -1) {
				this.areaTableData[this.allIndex].dataList = []
			} else {
				let arr = []
				let list = this.areaTableData[this.allIndex].dataList
				list.forEach(item => {
					if (item.transportMode !== 0) {
						arr.push(item)
					}
				})
				this.areaTableData[this.allIndex].dataList = arr
			}
			this.checkList.forEach(item => {
				let row = {
					transportMode: item,
					freemoney: '',
					fixedMoney: '',
					freightTemplatePricingDTOList: [{
						id: '',
						minValue: '0.00',
						maxValue: '',
						freightMoney: '',
						freightRatio: '',
						pricingType: 0,
						detailtype: 0
					}],
					freightTemplatePricingDTOList2: [{
						id: '',
						minValue: '0.00',
						maxValue: '',
						freightMoney: '',
						freightRatio: '',
						pricingType: 0,
						detailtype: 0
					}],
					minValue: '0.00',
					freightMoney: '',
					maxValue: '',
					stepValue: 1,
					stepMoney: '',
					stepValstepMoneyue: '',
					numberMoney: '',
					numberFixed: '',
					numberStepMoney: '',
					topOffRadio: '1',
					topOffValue: '',
					isError: -1,
					percentMoney: '',
					pricingType: 0,
					detailtype: 0
				}
				this.areaTableData[this.allIndex].dataList.push(row)
			})
			this.selectMethodShow = false
		},
		changeHandle () {
			this.isChanged = true
		},
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					console.log(this.AuthorityList)
					let add = window.sessionStorage.getItem('addFreight')
					if (add === 'true') {
						if (this.AuthorityList['01_0003_0002_00']) {
							this.isDisabled = false
						} else {
							this.isDisabled = true
						}
					} else {
						if (this.AuthorityList['01_0003_0001_00']) {
							this.isDisabled = false
						} else {
							this.isDisabled = true
						}
					}
				}
			})
		},
		// 是否对接中台
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.matchbillcenterflag = res.matchbillcenterflag
			})
		},
		delTimeClick (index, Index, allIndex) {
			this.areaTableData[allIndex].dataList[Index].freightTemplatePricingDTOList.splice(index, 1)
		},
		addTimeClick (value, Index, allIndex) {
			let row = {
				minValue: value,
				maxValue: '',
				freightMoney: '',
				freightRatio: '',
				isError: -1
			}
			this.areaTableData[allIndex].dataList[Index].freightTemplatePricingDTOList.push(row)
		},
		delTimeClick2 (index, Index, allIndex) {
			this.areaTableData[allIndex].dataList[Index].freightTemplatePricingDTOList2.splice(index, 1)
		},
		addTimeClick2 (value, Index, allIndex) {
			let row = {
				minValue: value,
				maxValue: '',
				freightMoney: '',
				freightRatio: '',
				isError: -1
			}
			this.areaTableData[allIndex].dataList[Index].freightTemplatePricingDTOList2.push(row)
		},
		checkSame (provinces) {
			let list = []
			let nameList = []
			this.areaTableData.forEach((item, index) => {
				if (item.provinces && index !== this.editIndex) {
					list = list.concat(item.provinces.split(','))
				}
			})
			provinces.forEach(item => {
				if (list.indexOf(item) !== -1) {
					nameList.push('【' + codeToCity[item] + '】')
				}
			})
			return	nameList
		},
		addArea (data) {
			let list = this.provinceList
			let checkArr = []
			let arr = []
			let flag = true
			let checkedArrHalf = []
			for (let i = 0; i < list.length; i++) {
				if (data.checkedArr[list[i]]) {
					if (data.checkedArr[list[i]].length > 0) {
						arr.push(list[i])
						flag = flag && false
					}
					checkArr = checkArr.concat(data.checkedArr[list[i]])
				}
				if (data.checkedArrHalf[list[i]]) {
					checkedArrHalf = checkedArrHalf.concat(data.checkedArrHalf[list[i]])
				}
			}
			if (flag) {
				this.$message.error('请选择配送区域')
				return false
			}
			let allArea = [...checkArr, ...checkedArrHalf]
			let allAreaName = allArea.map((item) => {
				return codeToCity[item]
			})
			let nameList = this.checkSame(data.provinces)
			if (nameList.length > 0) {
				this.$message.error('可配送区域' + nameList.join(',') + '已被添加')
				return false
			}
			if (this.addTree) {
				let row = {
					id: data.id,
					dataList: [
						{
							transportMode: 0,
							fixedMoney: '',
							freightTemplatePricingDTOList: [{
								id: '',
								minValue: '0.00',
								maxValue: '',
								freightMoney: '',
								freightRatio: '',
								pricingType: 0,
								detailtype: 0
							}],
							freightTemplatePricingDTOList2: [{
								id: '',
								minValue: '0.00',
								maxValue: '',
								freightMoney: '',
								freightRatio: '',
								pricingType: 0,
								detailtype: 0
							}],
							minValue: '0.00',
							freightMoney: '',
							maxValue: '',
							stepValue: 1,
							stepMoney: '',
							stepValstepMoneyue: '',
							numberMoney: '',
							numberFixed: '',
							numberStepMoney: '',
							topOffRadio: '1',
							topOffValue: '',
							isError: -1,
							percentMoney: '',
							pricingType: 0,
							detailtype: 0
						}
					],
					feeTollType: 0,
					bridgeTollType: 0,
					feeToll: 0,
					bridgeToll: 0,
					checkedArrHalf: data.checkedArrHalf,
					checkedArr: data.checkedArr,
					updateFullSelectedArea: checkArr,
					updateHalfSelectedArea: checkedArrHalf,
					provinces: data.provinces.join(','),
					areaname: allAreaName.join(','),
					freemoney: '',
					showname: allAreaName.slice(0, 21).join(',') + '...'
				}
				this.areaTableData.push(row)
				// this.changeHandle()
				// let list1 = this.areaTableData
				// let flag1 = true
				// for (let i = 0; i < list1.length; i++) {
				// 	if (list1[i].id === row.id) {
				// 		flag1 = false
				// 		this.areaTableData[i].areaname = row.areaname
				// 		this.areaTableData[i].showname = row.showname
				// 	}
				// }
				// if (flag1 === true) {
				// 	this.areaTableData.push(row)
				// }
			} else {
				this.areaTableData[this.editIndex].provinces = data.provinces.join(',')
				this.areaTableData[this.editIndex].areaname = allAreaName.join(',')
				this.areaTableData[this.editIndex].showname = allAreaName.slice(0, 21).join(',') + '...'
				this.areaTableData[this.editIndex].checkedArrHalf = data.checkedArrHalf
				this.areaTableData[this.editIndex].checkedArr = data.checkedArr
				this.areaTableData[this.editIndex].updateFullSelectedArea = checkArr
				this.areaTableData[this.editIndex].updateHalfSelectedArea = checkedArrHalf
			}
			this.dialogClose()
		},
		get () {
			let params = {
				id: this.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlSV}/order/freightTemplate/detail/get`,
				data: params
			}).then(res => {
				if (res.result) {
					this.templateName = res.data.name
					this.calcgiftFlag = res.data.calcgiftFlag
					this.modifyDate = res.data.modifyDate
					this.freemoney = res.data.freemoney
					this.freearea = res.data.freearea
					this.freeflag = res.data.freeflag
					let list = res.data.freightTemplateDetailDTOList || []
					if (list.length > 0) {
						list.forEach(item => {
							item.checkedArr = item.fullSelectedArea
							item.checkedArrHalf = item.halfSelectedArea
							let list = this.provinceList
							let checkArr = []
							let arr = []
							let checkedArrHalf = []
							for (let i = 0; i < list.length; i++) {
								if (item.checkedArr[list[i]]) {
									if (item.checkedArr[list[i]].length > 0) {
										arr.push(list[i])
									}
									checkArr = checkArr.concat(item.checkedArr[list[i]])
								}
								if (item.checkedArrHalf[list[i]]) {
									checkedArrHalf = checkedArrHalf.concat(item.checkedArrHalf[list[i]])
								}
							}
							item.updateFullSelectedArea = checkArr
							item.updateHalfSelectedArea = checkedArrHalf
							let nameArr = item.areaname.split(',')
							item.showname = item.areaname
							if (nameArr.length > 20) {
								item.showname = nameArr.slice(0, 21).join(',') + '...'
							}
							item.freemoney = item.freemoney ? this.$fxUtils.toFixedSHW(item.freemoney, 2) : ''
							item.dataList = []
							if (item.freightTemplatePricingDetail !== null) {
								item.dataList.push(this.initData(item.freightTemplatePricingDetail, 0))
							}
							if (item.simpleTemplatePricingDetail !== null) {
								item.dataList.push(this.initData(item.simpleTemplatePricingDetail, 1))
							}
							if (item.coldChainTemplatePricingDetail !== null) {
								item.dataList.push(this.initData(item.coldChainTemplatePricingDetail, 2))
							}
							// item.fixedMoney = this.$fxUtils.toFixedSHW(item.freightTemplatePricingDTOList[0].freightMoney, 2)
							// item.percentMoney = this.$fxUtils.toFixedSHW(item.freightTemplatePricingDTOList[0].freightRatio, 2)
							// item.topOffRadio = item.topOffValue ? '0' : '1'
							// item.isError = -1
							// let defaultList = [{
							// 	id: '',
							// 	minValue: '0.00',
							// 	maxValue: '',
							// 	freightMoney: '',
							// 	freightRatio: '',
							// 	pricingType: 0,
							// }]
							// if (item.pricingType === 0) {
							// 	item.freightTemplatePricingDTOList[0].freightMoney = ''
							// }
							// if (item.pricingType === 1) {
							// 	item.freightTemplatePricingDTOList.forEach(e => {
							// 		e.freightMoney = this.$fxUtils.toFixedSHW(e.freightMoney, 2)
							// 		e.minValue = this.$fxUtils.toFixedSHW(e.minValue, 2)
							// 		e.maxValue = e.maxValue === null ? '' : this.$fxUtils.toFixedSHW(e.maxValue, 2)
							// 		e.isError = -1
							// 	})
							// }
							// if (item.pricingType === 2) {
							// 	item.freightTemplatePricingDTOList[0].freightRatio = ''
							// }
							// if (item.pricingType === 5 || item.pricingType === 7) {
							// 	item.numberFixed = item.freightTemplatePricingDTOList[0].maxValue
							// 	item.numberMoney = this.$fxUtils.toFixedSHW(item.freightTemplatePricingDTOList[0].freightMoney, 2)
							// 	item.numberStepMoney = this.$fxUtils.toFixedSHW(item.freightTemplatePricingDTOList[0].stepMoney, 2)
							// 	item.topOffValue = item.freightTemplatePricingDTOList[0].topOffValue
							// 	item.topOffRadio = item.freightTemplatePricingDTOList[0].topOffValue ? '2' : '1'
							// }
							// if (item.pricingType === 6) {
							// 	item.freightTemplatePricingDTOList2 = this.$fxUtils.deepClone(item.freightTemplatePricingDTOList)
							// 	item.freightTemplatePricingDTOList2.forEach(e => {
							// 		e.freightMoney = this.$fxUtils.toFixedSHW(e.freightMoney, 2)
							// 		e.isError = -1
							// 	})
							// 	item.freightTemplatePricingDTOList = defaultList
							// } else {
							// 	defaultList[0].minValue = 0
							// 	item.freightTemplatePricingDTOList2 = defaultList
							// }
						})
					}
					this.areaTableData = list
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		initData (item, type) {
			item.transportMode = type
			if (item.detailtype === undefined || item.detailtype === null) {
				item.detailtype = 0
			}
			item.fixedMoney = this.$fxUtils.toFixedSHW(item.freightTemplatePricingDTOList[0].freightMoney, 2)
			item.percentMoney = this.$fxUtils.toFixedSHW(item.freightTemplatePricingDTOList[0].freightRatio, 2)
			item.topOffRadio = item.topOffValue ? '0' : '1'
			item.isError = -1
			let defaultList = [{
				id: '',
				minValue: '0.00',
				maxValue: '',
				freightMoney: '',
				freightRatio: '',
				pricingType: 0,
				detailtype: 0
			}]
			if (item.pricingType === 0) {
				item.freightTemplatePricingDTOList[0].freightMoney = ''
			}
			if (item.pricingType === 1) {
				item.freightTemplatePricingDTOList.forEach(e => {
					e.freightMoney = this.$fxUtils.toFixedSHW(e.freightMoney, 2)
					e.minValue = this.$fxUtils.toFixedSHW(e.minValue, 2)
					e.maxValue = e.maxValue === null ? '' : this.$fxUtils.toFixedSHW(e.maxValue, 2)
					e.isError = -1
				})
			}
			if (item.pricingType === 2) {
				item.freightTemplatePricingDTOList[0].freightRatio = ''
			}
			if (item.pricingType === 5 || item.pricingType === 7) {
				item.numberFixed = item.freightTemplatePricingDTOList[0].maxValue
				item.numberMoney = this.$fxUtils.toFixedSHW(item.freightTemplatePricingDTOList[0].freightMoney, 2)
				item.numberStepMoney = this.$fxUtils.toFixedSHW(item.freightTemplatePricingDTOList[0].stepMoney, 2)
				item.topOffValue = item.freightTemplatePricingDTOList[0].topOffValue
				item.topOffRadio = item.freightTemplatePricingDTOList[0].topOffValue ? '2' : '1'
			}
			if (item.pricingType === 10) {
				item.numberFixed = item.freightTemplatePricingDTOList[0].maxValue
				item.numberMoney = this.$fxUtils.toFixedSHW(item.freightTemplatePricingDTOList[0].freightMoney, 2)
				item.numberStepMoney = this.$fxUtils.toFixedSHW(item.freightTemplatePricingDTOList[0].stepMoney, 2)
			}
			if (item.pricingType === 9 || item.pricingType === 6) {
				item.freightTemplatePricingDTOList2 = this.$fxUtils.deepClone(item.freightTemplatePricingDTOList)
				item.freightTemplatePricingDTOList2.forEach(e => {
					e.freightMoney = this.$fxUtils.toFixedSHW(e.freightMoney, 2)
					e.isError = -1
				})
				item.freightTemplatePricingDTOList = defaultList
			} else {
				defaultList[0].minValue = 0
				item.freightTemplatePricingDTOList2 = defaultList
			}
			return item
		},
		dialogClose () {
			this.showTree = false
			this.addTree = false
		},
		submitForm () {
			// return new Promise((resolve, reject) => {
			if (!this.templateName) {
				this.$message.error('模板名称不能为空！')
				// reject()
				return false
			}
			if (this.areaTableData.length === 0) {
				this.$message.error('模板配送区域不能为空！')
				// reject()
				return false
			}
			if ((this.freemoney === '' || this.freemoney === null) && this.freeflag && this.freearea === 0) {
				this.$message.error('请填写免运费订单金额')
				return false
			}
			let isError = false
			let flag = true
			for (let index = 0; index < this.areaTableData.length; index++) {
				let allItem = this.areaTableData[index].dataList
				if (!(this.areaTableData[index].freemoney && this.areaTableData[index].freemoney !== '') && this.freeflag && this.freearea === 1) {
					this.$message.error('请填写免运费订单金额')
					flag = false
					return false
				}
				allItem.forEach(item => {
					if (item.pricingType === 0) {
						if (item.fixedMoney === '' || item.fixedMoney === null) {
							item.isError = 0
							isError = true
						} else {
							item.freightTemplatePricingDTOList[0].freightMoney = item.fixedMoney
							item.freightTemplatePricingDTOList[0].pricingType = item.pricingType
							item.freightTemplatePricingDTOList.length = 1
							item.isError = -1
						}
						item.freightTemplatePricingDTOList[0].freightMoney = item.fixedMoney
					}
					if (item.pricingType === 1) {
						let item1 = item.freightTemplatePricingDTOList
						for (let j = 0; j < item1.length; j++) {
							let e = item1[j]
							e.pricingType = item.pricingType
							if (e.maxValue && +e.maxValue <= +e.minValue) {
								this.$message.error('请设置大于起始金额的数值！')
								flag = false
								return false
							} else if (e.freightMoney === '' || e.freightMoney === null) {
								e.isError = 1
								isError = true
							} else {
								e.isError = -1
							}
						}
					}
					if (item.pricingType === 2) {
						if (item.percentMoney === '' || item.percentMoney === null) {
							item.isError = 2
							isError = true
						} else {
							item.freightTemplatePricingDTOList[0].freightRatio = item.percentMoney
							item.freightTemplatePricingDTOList[0].pricingType = item.pricingType
							item.freightTemplatePricingDTOList.length = 1
							item.isError = -1
						}
						item.freightTemplatePricingDTOList[0].freightRatio = item.percentMoney
					}
					if (item.pricingType === 5 || item.pricingType === 7) {
						if (!item.numberFixed || !item.numberMoney || !item.numberStepMoney || (item.topOffRadio === '2' && !item.topOffValue)) {
							item.isError = item.pricingType
							isError = true
						} else {
							item.freightTemplatePricingDTOList[0].maxValue = item.numberFixed
							item.freightTemplatePricingDTOList[0].freightMoney = item.numberMoney
							item.freightTemplatePricingDTOList[0].stepMoney = item.numberStepMoney
							item.freightTemplatePricingDTOList[0].topOffValue = item.topOffRadio === '1' ? '' : item.topOffValue
							item.freightTemplatePricingDTOList[0].pricingType = item.pricingType
							item.freightTemplatePricingDTOList.length = 1
							item.isError = -1
						}
					}
					if (item.pricingType === 6) {
						let item1 = item.freightTemplatePricingDTOList2
						for (let j = 0; j < item1.length; j++) {
							let e = item1[j]
							e.pricingType = item.pricingType
							if (e.maxValue && +e.maxValue <= +e.minValue) {
								this.$message.error('请设置大于起始件数的数值！')
								flag = false
								return false
							} else if (e.freightMoney === '' || e.freightMoney === null) {
								e.isError = 6
								isError = true
							} else {
								e.isError = -1
							}
						}
						item.freightTemplatePricingDTOList = item1
					}
					if (item.pricingType === 9) {
						let item1 = item.freightTemplatePricingDTOList2
						for (let j = 0; j < item1.length; j++) {
							let e = item1[j]
							e.pricingType = item.pricingType
							if (e.maxValue && +e.maxValue <= +e.minValue) {
								this.$message.error('请设置大于起始件数的数值！')
								flag = false
								return false
							} else if (e.freightMoney === '' || e.freightMoney === null) {
								e.isError = 9
								isError = true
							} else {
								e.isError = -1
							}
						}
						item.freightTemplatePricingDTOList = item1
					}
					if (item.pricingType === 10) {
						if (!item.numberFixed || !item.numberMoney || !item.numberStepMoney) {
							item.isError = item.pricingType
							isError = true
						} else {
							item.freightTemplatePricingDTOList[0].maxValue = item.numberFixed
							item.freightTemplatePricingDTOList[0].freightMoney = item.numberMoney
							item.freightTemplatePricingDTOList[0].stepMoney = item.numberStepMoney
							item.freightTemplatePricingDTOList[0].pricingType = item.pricingType
							item.freightTemplatePricingDTOList.length = 1
							item.isError = -1
						}
					}
				})
			}
			if (!flag) {
				// reject()
				return false
			}
			if (isError) {
				this.$message.error('请输入计费规则！')
				// reject()
				return false
			}
			let list = this.initParams(this.areaTableData)
			// list.forEach(e => {
			// 	if (e.pricingType === 0) {
			// 		e.freightTemplatePricingDTOList[0].freightMoney = e.fixedMoney
			// 	}
			// 	if (e.pricingType === 2) {
			// 		e.freightTemplatePricingDTOList[0].freightRatio = e.percentMoney
			// 	}
			// })
			// let logger = this.$fxLogger.createInfo('seller.freight.info', this.initLogger(list))
			let logger = this.initLogger(list)
			let url = window.location.href.split('?')[0]
			url = url.replace(window.location.origin, '').substring(1)
			let params = {
				id: this.id,
				type: 0,
				name: this.templateName,
				calcgiftFlag: this.calcgiftFlag,
				freightTemplateDetailDTOList: list,
				freeflag: this.freeflag,
				freearea: this.freearea,
				freemoney: this.freemoney,
				logMessage: {
					message: logger,
					referer: url
				}
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/freightTemplate/save`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功')
					// this.get()
					if (res.data.productTransportMode !== null) {
						let text = '检查到您可售商品库中存在' + (res.data.productTransportMode === 1 ? '常温运输' : '冷链运输') + '的商品，但您当前新增模版中存在地区未配置' + (res.data.productTransportMode === 1 ? '常温运输' : '冷链运输') + '，可能会影响最终运费计算。'
						this.waringText = text
						this.waringShow = true
					} else {
						this.$router.push('/main/freight')
						this.isChanged = false
					}
					// resolve('success')
				} else {
					this.$message.error(res.msg)
					// reject()
				}
			})
			// })
		},
		initLogger (list) {
			let text = '模板名称：' + this.templateName + ',赠品是否计算运费:' + (this.calcgiftFlag ? '是' : '否') + ','
			list.forEach(item => {
				if (item.freightTemplatePricingDetail) {
					text = text + item.areaname + this.dataToText(item.freightTemplatePricingDetail, 0)
				}
				if (item.coldChainTemplatePricingDetail) {
					text = text + item.areaname + this.dataToText(item.coldChainTemplatePricingDetail, 1)
				}
				if (item.simpleTemplatePricingDetail) {
					text = text + item.areaname + this.dataToText(item.simpleTemplatePricingDetail, 2)
				}
			})
			return text
		},
		dataToText (data, type) {
			let text = ''
			let pricingType = data.pricingType
			switch (type) {
			case 0:
				text = '运输方式:不限,'
				break
			case 2:
				text = '运输方式:常温运输,'
				break
			case 1:
				text = '运输方式:冷链运输,'
				break
			}
			switch (pricingType) {
			case 0:
				text = text + '计费方式：一口价'
				break
			case 1:
				text = text + '计费方式：按订单金额：阶梯价'
				break
			case 2:
				text = text + '计费方式：按订单金额：比例价'
				break
			case 5:
				text = text + '计费方式：按订单件数：固定件数'
				break
			case 6:
				text = text + '计费方式：按订单件数：阶梯件数'
				break
			case 7:
				text = text + '计费方式：按订单重量：固定重量'
				break
			case 9:
				text = text + '计费方式：按订单件数：阶梯件数'
				break
			case 10:
				text = text + '计费方式：按订单件数：一律每件'
				break
			}
			if (pricingType === 9) {
				let list = data.freightTemplatePricingDTOList || []
				let detailtypeText = data.detailtype === 1 ? '超出起送件数，超出部分每件' : '超出起送件数，每件'
				list.forEach((tier, tierIndex) => {
					if (tierIndex === 0) {
						text = text + tier.minValue + ' ~ ' + tier.maxValue + ' 件（不含），运费固定 ' + tier.freightMoney + ' 元，' + detailtypeText
					} else {
						text = text + tier.minValue + ' ~ ' + tier.maxValue + ' 件（不含），按照每件 ' + tier.freightMoney + ' 元收取'
					}
				})
			}
			data.freightTemplatePricingDTOList.forEach(item => {
				if (item.pricingType === 0) {
					text = text + '一口价' + item.freightMoney + '元'
				}
				if (item.pricingType === 1) {
					text = text + '订单金额于' + item.minValue + ' 元（含）~' + item.maxValue + '元（不含），收' + item.freightMoney + '元'
				}
				if (item.pricingType === 2) {
					text = text + '订单金额比例的' + item.percentMoney + '%'
				}
				if (item.pricingType === 5) {
					text = text + '首费：' + item.maxValue + '件（包含及以下）,' + item.freightMoney + '元；续费：超出每件' + item.stepMoney + '元；' + (item.topOffValue ? '封顶' + item.topOffValue + '件' : '无封顶')
				}
				if (item.pricingType === 6) {
					text = text + '订单件数于' + item.minValue + '件（含）~' + item.maxValue + '件（不含），收' + item.freightMoney + '元'
				}
				if (item.pricingType === 7) {
					text = text + '首费：' + item.maxValue + 'KG（包含及以下）,' + item.freightMoney + '元；续费：超出每KG' + item.stepMoney + '元；' + (item.topOffValue ? '封顶' + item.topOffValue + 'KG' : '无封顶')
				}
				if (item.pricingType === 10) {
					text = text + '0~' + item.minValue + '件，起步价' + item.freightMoney + '元，只要超出起步件数，一律按照每件' + item.stepMoney + '元收取'
				}
			})
			return text
		},
		closeWaring () {
			this.waringShow = false
			this.isChanged = false
			this.$router.push('/main/freight')
		},
		initParams (data) {
			let arr = []
			data.forEach(item => {
				let row = {
					freemoney: item.freemoney,
					areaname: item.areaname,
					feeTollType: item.feeTollType,
					bridgeTollType: item.bridgeTollType,
					feeToll: item.feeToll,
					bridgeToll: item.bridgeToll,
					checkedArr: item.checkedArr,
					checkedArrHalf: item.checkedArrHalf,
					id: item.id,
					provinces: item.provinces,
					updateFullSelectedArea: item.updateFullSelectedArea,
					updateHalfSelectedArea: item.updateHalfSelectedArea,
					showname: item.showname
				}
				let list = item.dataList
				list.forEach(dataItem => {
					if (dataItem.transportMode === 0) {
						let detail = {
							pricingType: dataItem.pricingType,
							detailtype: dataItem.detailtype,
							freightTemplatePricingDTOList: dataItem.freightTemplatePricingDTOList
						}
						row.freightTemplatePricingDetail = detail
					}
					if (dataItem.transportMode === 1) {
						let detail = {
							pricingType: dataItem.pricingType,
							detailtype: dataItem.detailtype,
							freightTemplatePricingDTOList: dataItem.freightTemplatePricingDTOList
						}
						row.simpleTemplatePricingDetail = detail
					}
					if (dataItem.transportMode === 2) {
						let detail = {
							pricingType: dataItem.pricingType,
							detailtype: dataItem.detailtype,
							freightTemplatePricingDTOList: dataItem.freightTemplatePricingDTOList
						}
						row.coldChainTemplatePricingDetail = detail
					}
				})
				arr.push(row)
			})
			return arr
		},
		areaChange (row, key, i, allIndex) {
			if (this.areaTableData[allIndex].dataList[i][key] === '' || this.areaTableData[allIndex].dataList[i][key] < 0 || parseFloat(this.areaTableData[allIndex].dataList[i][key]).toString() === 'NaN') {
				this.areaTableData[allIndex].dataList[i][key] = 0
			} else if (this.areaTableData[allIndex].dataList[i][key] > 9999999.99 && (key === 'percentMoney' || key === 'freightstep')) {
				this.areaTableData[allIndex].dataList[i][key] = '9999999.99'
			} else {
				this.areaTableData[allIndex].dataList[i][key] = this.$fxUtils.toFixedSHW(this.areaTableData[allIndex].dataList[i][key], 2)
			}
			row.isError = -1
			this.changeHandle()
		},
		areaChange2 (row, key, i, allIndex) {
			if (key === 'numberFixed' || key === 'topOffValue') {
				if (this.areaTableData[allIndex].dataList[i][key] === '' || this.areaTableData[allIndex].dataList[i][key] < 0 || parseFloat(this.areaTableData[allIndex].dataList[i][key]).toString() === 'NaN') {
					this.areaTableData[allIndex].dataList[i][key] = 0
				} else if (this.areaTableData[allIndex].dataList[i][key] > 9999999) {
					this.areaTableData[allIndex].dataList[i][key] = 9999999
				}
			} else {
				if (this.areaTableData[allIndex].dataList[i][key] === '' || this.areaTableData[allIndex].dataList[i][key] < 0 || parseFloat(this.areaTableData[allIndex].dataList[i][key]).toString() === 'NaN') {
					this.areaTableData[allIndex].dataList[i][key] = 0
				} else if (this.areaTableData[allIndex].dataList[i][key] > 9999999.99) {
					this.areaTableData[allIndex].dataList[i][key] = '9999999.99'
				} else {
					this.areaTableData[allIndex].dataList[i][key] = this.$fxUtils.toFixedSHW(this.areaTableData[allIndex].dataList[i][key], 2)
				}
			}
			row.isError = -1
			this.changeHandle()
		},
		stepMoneyChange (index, Index, key, allIndex) {
			let item = this.areaTableData[allIndex].dataList[Index].freightTemplatePricingDTOList[index][key]
			if (item === '' || item < 0 || parseFloat(item).toString() === 'NaN') {
				this.areaTableData[allIndex].dataList[Index].freightTemplatePricingDTOList[index][key] = 0
			} else if (item > 9999999.999 && (key === 'percentMoney' || key === 'freightstep')) {
				this.areaTableData[allIndex].dataList[Index].freightTemplatePricingDTOList[index][key] = '9999999.99'
			} else {
				this.areaTableData[allIndex].dataList[Index].freightTemplatePricingDTOList[index][key] = this.$fxUtils.toFixedSHW(item, 2)
			}
			this.areaTableData[allIndex].dataList[Index].freightTemplatePricingDTOList[index].isError = -1
			this.changeHandle()
		},
		stepMoneyChange2 (index, Index, key, allIndex) {
			let item = this.areaTableData[allIndex].dataList[Index].freightTemplatePricingDTOList2[index][key]
			if (key === 'maxValue') {
				if (item > 9999999) {
					this.areaTableData[allIndex].dataList[Index].freightTemplatePricingDTOList2[index][key] = 9999999
				}
			} else if (key === 'freightMoney') {
				if (item === '' || item < 0 || parseFloat(item).toString() === 'NaN') {
					this.areaTableData[allIndex].dataList[Index].freightTemplatePricingDTOList2[index][key] = 0
				} else if (item > 9999999.999) {
					this.areaTableData[allIndex].dataList[Index].freightTemplatePricingDTOList2[index][key] = '9999999.99'
				} else {
					this.areaTableData[allIndex].dataList[Index].freightTemplatePricingDTOList2[index][key] = this.$fxUtils.toFixedSHW(item, 2)
				}
			}
			this.areaTableData[allIndex].dataList[Index].freightTemplatePricingDTOList2[index].isError = -1
			this.changeHandle()
		},
		deleteClick (allIndex, index) {
			// this.$confirm('是否要删除？', '提示', {
			// 	confirmButtonText: '确定',
			// 	cancelButtonText: '取消',
			// 	type: 'warning',
			// 	closeOnClickModal: false
			// }).then(() => {
			// 	let params = {
			// 		id: id
			// 	}
			// 	this.$store.dispatch('requestPost', {
			// 		url: `${this.$fxBaseApi.urlQIV}/shop/freight/detail/remove`,
			// 		data: params
			// 	}).then(res => {
			// 		if (res.result) {
			// 			this.$message.success('删除成功')
			// 			this.areaTableData.splice(index, 1)
			// 		} else {
			// 			this.$message.error(res.msg)
			// 		}
			// 	})
			// }).catch(() => {})
			this.areaTableData[allIndex].dataList.splice(index, 1)
			if (this.areaTableData[allIndex].dataList.length === 0) {
				this.areaTableData.splice(allIndex, 1)
			}
		},
		editTree (item, index) {
			this.treeId = item.id
			this.checkedArr = item.checkedArr
			this.checkedArrHalf = item.checkedArrHalf
			this.editIndex = index
			this.showTree = true
			this.addTree = false
		},
		addClick () {
			if (!this.AuthorityList['01_0003_0002_00']) {
				return false
			}
			this.treeId = ''
			this.showTree = true
			this.addTree = true
			this.editIndex = null
		},
		goBack () {
			this.$router.push('/main/freight')
		}
	}
}
</script>

<style  lang="stylus" scoped>
.row-box{
	display: flex;
	height: 40px;
	align-items: center;
	.cell-input{
		width: 120px;
		margin: 0 10px;
	}
}
.store-name {
	border-bottom: 1px solid #dce2fd;
	height:66px;
	min-height: 66px;
	line-height: 66px;
	box-sizing border-box
	span {
		font-size: 18px;
		font-weight: bold
		float left
		display inline-block
		line-height 66px
		padding-right 20px
		i {
			border-radius: 50%;
			background: #9da6af;
			padding: 3px;
			cursor: pointer;
		}
		.el-icon-back {
			content: "\E6EA";
			color: #fff;
			font-weight: bold;
		}
	}
}
.btn-row{
	height: 40px;
	border: 1px solid #D5D5D5
	border-top: 0
	display: flex;
}
.container{
    overflow :auto;
    text-align :left;
    box-sizing :border-box;
    width :100%;
    padding-top :10px;
    height:calc(100% - 120px);
	font-size: 14px;
	.template-name {
		display: flex;
		align-items: center;
		.name-input {
			width: 250px;
			margin: 0 30px 0 10px;
		}
		.edit-time {
			margin-left: auto;
			color: #999;
			margin-right: 50px;
		}
	}
	.btn-feight-box{
        margin 10px;
		display: flex
    }
    .table-box{
		flex: 1;
		min-height: 0;
        margin-top :10px;
		.table-wrap {
			height: 100%;
			overflow: hidden;
			overflow-y: auto;
			// display: flex;
			// flex-direction: column;
		}
        .freight-table-head {
			width: 100%;
			display: flex;
			height: 40px;
			line-height: 40px;
			.flex-one, .flex-two, .flex-four {
				text-align: center;
				height: 100%;
				background: #F7F7F7;
			}
		}
		.freight-content-wrap {
			// flex: 1;
			// overflow: hidden;
			// overflow-y: auto;
		}
		.freight-table-content {
			width: 100%;
			display: flex;
		}
		.flex-one {
			flex: 3;
			border: 1px solid #D5D5D5;
			box-sizing: border-box;
			border-right: 0
		}
		.flex-all{
			flex: 6.5;
			display: flex;
			box-sizing: border-box
			border-right: 0
		}
		.flex-four{
			flex: 1.5;
			border: 1px solid #D5D5D5;
			box-sizing: border-box;
			border-right: 0;
			display: flex;
			align-items: center;
			justify-content: center
		}
		.flex-two{
			flex: 5;
			box-sizing: border-box;
			border: 1px solid #D5D5D5;
		}
		.flex-three {
			width: 150px
		}
        .grid-content{
            box-sizing :border-box;
            height :100%;
            overflow-y :auto
        }
		.cell-input{
            width :120px;
			margin: 0 10px;
        }
		.rule-box {
			text-align: left;
			padding-left: 20px
			height: 100%;
			display: flex;
			align-items: center;
			&.two-box {
				flex-direction: column;
				.two-wrap {
					width: 100%
				}
			}
			.two-wrap:last-of-type {
				.step-box {
					margin-bottom: 0
				}
			}
			.step-box {
				margin-bottom: 10px;
				.cell-input{
					width :100px;
					margin: 0 6px;
				}
			}
			.time-btn{
				padding:2px !important
				&:first-of-type {
					margin-left: 10px
				}
			}
		}
    }
    .time-box{
        width:300px;
        height :40px;
        line-height :40px;
        margin-left:80px;
    }
	.freight-type {
		display: flex
		align-items: center
		margin-top: 10px
		border-left: 4px solid var(--fx-primary-color);
		img {
			width: 25px;
			height: 25px
		}
		.type-title {
			font-size: 16px
			margin: 0 30px 0 10px;
		}
		.type-effect {
			color: var(--fx-primary-color);
			margin-left: 30px;
		}
	}
	.choose-text {
		margin: 15px 0 10px;
	}
	.type-text {
		color: #999;
		margin-left: 15px
	}
	.method-box {
		display: flex;
		width: 300px;
		height: 90px;
		border: 1px solid #eee;
		border-radius: 10px;
		padding: 15px 20px;
		box-sizing: border-box;
		color: #999;
		cursor: pointer;
		margin-right: 30px;
		img {
			width: 28px;
			height: 28px;
			margin-right: 10px;
		}
		.method-p {
			margin: 5px 0 10px;
			font-weight: bold;
		}
		.method-intro {
			font-size: 13px;
		}
		&.select {
			border: 1px solid #8EB5FF;
			background-color: #F7FAFE;
			.method-p {
				color: var(--fx-primary-color)
			}
		}
	}
	.area-add {
		margin-left: 5px;
		cursor: pointer;
		font-size: 16px;
		color: #999;
	}
	.tip-icon {
		display: inline-block;
		cursor: pointer;
		margin-left: 10px;
	}
	.self-input{
		width :100px;
		margin: 20px 10px 0
	}
}
</style>
<style lang="stylus">
.el-dialog__body{
    padding:0px 20px 20px 20px
}
.flag-switch .el-switch__label {
	position: absolute;
	display: none;
	color: #fff;
}
.input-error .el-input__inner {
	border-color: #F56C6C;
}
/*打开时文字位置设置*/
.flag-switch .el-switch__label--right {
	z-index: 1;
	right: -7px;
}
/*关闭时文字位置设置*/
.flag-switch .el-switch__label--left {
	z-index: 1;
	left: 20px;
}
/*显示文字*/
.flag-switch .el-switch__label.is-active {
	display: block;
}
.flag-switch.el-switch .el-switch__core, .el-switch .el-switch__label {
	width: 40px !important;
}
.method-intro {
	.el-radio__label,.el-radio__input.is-checked+.el-radio__label {
		color: #333;
	}
}
.el-tooltip__popper.is-dark.tip-class {
	width: 250px
}
</style>
